const validatePhone = (phone) => {
  if (phone.startsWith("+")) return phone;
  if (phone.startsWith("91")) return `+${phone}`;
  if (phone.startsWith("0")) return `+91${phone.substring(1)}`;
  return `+91${phone}`;
};

export default validatePhone;
